function SeparateCountryCodeFromNumber(num) {
  return num.replace('+98', '0');
}
export default SeparateCountryCodeFromNumber;
